interface DisplayFieldProps {
  label: string;
  value: string;
}

export const DisplayField = ({ label, value }: DisplayFieldProps) => {
  return (
    <div className="flex flex-col py-2 w-48">
      <label className="pb-2 font-semibold">{label}</label>
      <span>{value}</span>
    </div>
  );
};
